import { SourcesComposition } from "../../../../components/composition/SourcesComposition";
import { usePageContext } from "../../../../components/navigation/PageContext";
import { SessionMode } from "../../../../contexts/appStore/hooks";
import { useComposition } from "../../../../hooks/composition";
import styles from "./composition.module.css";

/**
 * Full-screen wall of the sources configured in `settings.compositions`.
 *
 * Registered in both route trees: it reads the settings and opens local devices,
 * touching no API at all, so it works logged out exactly as it does logged in.
 * No chrome either — it is meant for a display nobody is sitting in front of.
 */
export const CompositionPage = () => {
  const pageContext = usePageContext<SessionMode.MASTER>();
  const id = pageContext?.params?.id;
  const { composition, notFound } = useComposition(id);

  if (notFound || !composition) {
    return (
      <div className={styles.page}>
        <div className={styles.message}>
          {id
            ? <>Aucune composition «&nbsp;{id}&nbsp;» dans la configuration.</>
            : <>Aucune composition configurée.</>}
        </div>
      </div>
    );
  }

  return (
    <div className={styles.page} style={{ background: composition.background }}>
      <SourcesComposition composition={composition} />
    </div>
  );
};

export default CompositionPage;
